// src/context/unitPartition/reducer.ts
import { IUnitPartitionQuery } from "../../models/unit-partition/query";
import { IUnitPartition, IUnitPartitionDetails } from "../../models/unit-partition/response";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import toggleLoading from "../../utils/helpers/xor";
import paramsReducer from "../base/base-reducer";
import { QueryAction } from "../base/base-reducer";
import { IInternalState, UnitPartitionLoading } from "./context";

type Action =
  | { type: "LOADING"; payload: { loading: UnitPartitionLoading | UnitPartitionLoading[] } }
  | { type: "SET_LIST"; payload: { list: IBaseListingResponse<IUnitPartition> } }
  | { type: "SET_DETAILS"; payload: { details?: IUnitPartitionDetails } }
  | QueryAction<IUnitPartitionQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING":
      return { ...state, loading: toggleLoading(state.loading, action.payload.loading) };
    case "SET_LIST":
      return { ...state, list: action.payload.list };
    case "SET_DETAILS":
      return { ...state, details: action.payload.details };
    default:
      return paramsReducer(state, action);
  }
};

export default reducer;
